import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import Home from "./Pages/Home";
import TagManager from 'react-gtm-module';

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
        children: [
        ],
    },
  {
    path: "/testdevice",
    element: <RedirectToTestDevice />
  }
]);


function RedirectToTestDevice() {
  React.useEffect(() => {
    window.location.replace('/testdevice.html');
  }, []);
  return <div>Redirecting...</div>; // Fallback
}

let okToLoad = false;
if(window.location.host === "sportstechinc.com") {
  window.location.host = "www.sportstechinc.com"
}else{
  okToLoad = true;
}

if(okToLoad){
  const tagManagerArgs = {
      gtmId: 'GTM-TC5WG86G'
  }

  TagManager.initialize(tagManagerArgs)

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );

}
